import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b9443aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "view-controls d-flex"
}

import { computed } from "vue";
import { ViewType } from "@/classes/data-structures/view-type"
import { useAppStateStore } from "@/store/app-state";


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewControls',
  setup(__props) {


const state = useAppStateStore();

// const canShow2D = computed(() => {
// 	return state.availableViewTypes.includes(ViewType.View2D);
// });

// const canShow3D = computed(() => {
// 	return state.availableViewTypes.includes(ViewType.View3D);
// });

const currentViewType = computed(() => {
	return state.viewType;
});

function switchView(view: ViewType) {
	state.setViewType(view);
}


return (_ctx: any,_cache: any) => {
  return (_unref(state).availableViewTypes.length == 2)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: _normalizeClass(["flex-fill", { active: _unref(currentViewType) == _unref(ViewType).View2D }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (switchView(_unref(ViewType).View2D)))
        }, " 2D ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["flex-fill", { active: _unref(currentViewType) == _unref(ViewType).View3D }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (switchView(_unref(ViewType).View3D)))
        }, " 3D ", 2)
      ]))
    : _createCommentVNode("", true)
}
}

})